/**
 * De onde o operador veio ao abrir o cadastro de uma empresa.
 *
 * A carteira de fornecedores e a de assessores abrem a mesma tela
 * (`EmpresaDetalhe`), mas quem clicou num fornecedor quer voltar para a lista
 * de fornecedores — não para a listagem geral de empresas, onde teria de achar
 * a carteira de novo. A origem vai por query (`?de=fornecedores`) porque o
 * histórico do navegador não é confiável para isso: a página pode ter sido
 * aberta por link direto ou em aba nova, e `history.back()` levaria a qualquer
 * lugar.
 *
 * Quem escreve o parâmetro (`Carteira`) e quem o lê (`EmpresaDetalhe`) passam
 * por aqui, para o nome da query e os valores aceitos não divergirem em dois
 * arquivos.
 */

export const PARAMETRO_DE_ORIGEM = 'de';

export const ORIGENS = {
  empresas: { rota: '/empresas', rotulo: 'Empresas' },
  // As carteiras viraram filtros de Empresas: o "Voltar" devolve ao filtro.
  fornecedores: { rota: '/empresas?perfis=fornecedores', rotulo: 'Fornecedores' },
  assessores: { rota: '/empresas?perfis=assessores', rotulo: 'Assessores' },
} as const;

export type Origem = keyof typeof ORIGENS;

/** Rota do cadastro da empresa carregando a origem, para o "Voltar" de lá. */
export function rotaDaEmpresa(businessId: string, origem: Exclude<Origem, 'empresas'>): string {
  return `/empresas/${businessId}?${PARAMETRO_DE_ORIGEM}=${origem}`;
}

/**
 * Qualquer valor fora da lista cai em "empresas": a query é digitável, e um
 * `?de=//outro-site` não pode virar destino de link. Sem parâmetro, o cadastro
 * foi aberto pela listagem geral — que é para onde "Voltar" sempre levou.
 */
export function origemDaQuery(valor: string | null): Origem {
  return valor === 'fornecedores' || valor === 'assessores' ? valor : 'empresas';
}
